import { FEATURES } from "@lib/enums";

interface PlanWithFeatures {
  features?: Array<{ type: string }>;
}

/**
 * Whether the `/me` plan grants SOLA. The API merges add-on plan features
 * (e.g. the SOLA add-on) into `plan.features`.
 */
export function hasSolaFeature(plan: PlanWithFeatures | null | undefined): boolean {
  return plan?.features?.some((feature) => feature.type === FEATURES.SOLA) ?? false;
}
